/**
 * @generated SignedSource<<5fe9c4a249b04e35800b8ce5f26c994c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountMenuSessionInfo$data = {
  readonly member: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member" | "UserHandle_member">;
  } | null;
  readonly " $fragmentType": "AccountMenuSessionInfo";
};
export type AccountMenuSessionInfo$key = {
  readonly " $data"?: AccountMenuSessionInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountMenuSessionInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountMenuSessionInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserHandle_member"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatar_member"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SessionInfo",
  "abstractKey": null
};

(node as any).hash = "26d875d1d952d113b3d0f8ee6402b11e";

export default node;
